import React from 'react';
import {
  Grid,
  Paper,
  Typography,
  Skeleton,
  Divider,
  Box
} from '@mui/material';

const OutOfStockByBranchGrid = ({ branches = [], outOfStockByBranch = {}, loading }) => {
  if (!branches.length || !outOfStockByBranch) return null;

  return (
    <Grid container spacing={2} mt={0}>
      {branches.map((branch, index) => {
        const data = outOfStockByBranch[branch.id] || [];

        return (
          <Grid item xs={12} md={4} key={branch.id}>
            <Paper elevation={2} sx={{ p: 2, height: 300, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="subtitle1" gutterBottom>
                🚫 Sin stock – {branch.name}
              </Typography>

              {loading ? (
                <Skeleton variant="rectangular" height={200} />
              ) : (
                <Box
                  sx={{
                    overflowY: 'auto',
                    mt: 1,
                    pr: 1,
                  }}
                >
                  {data.map((item, idx) => (
                    <Box key={idx}>
                      <Typography
                        variant="body2"
                        sx={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          mb: 0.5,
                        }}
                      >
                        {item.product}
                      </Typography>
                      {idx < data.length - 1 && <Divider />}
                    </Box>
                  ))}
                </Box>
              )}
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default OutOfStockByBranchGrid;
